import { YesNoCancelModal } from "%modals";

export default onProceed => ({
  methods: {
    resetForm() {
      this.$emit("show-modal", {
        component: YesNoCancelModal,
        props: {
          title: "Wyczyść wprowadzone zmiany",
          content: `
            <p>Czy na pewno chcesz wyczyścić <strong>wszystkie</strong> wprowadzone na niniejszej stronie zmiany?</p>
            <p>Operacja jest <strong>nieodwracalna</strong>!</p>
          `,
          proceed: {
            type: "is-danger",
            icon: "fa-trash",
            content: "Wyczyść",
            callback: onProceed.bind(this)
          },

          cancel: {
            content: "Anuluj"
          }
        }
      });
    }
  }
});
